import ArrModal from '../../../../../../common/arr-modal/ArrModal';
import {t} from 'i18next';
import './IssueCodeDeleteModal.scss';
import {Typography} from '@mui/material';

interface IssueCodeDeleteModalProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

const IssueCodeDeleteModal = ({
  open,
  onClose,
  onConfirm,
}: IssueCodeDeleteModalProps) => {
  return (
    <ArrModal
      className="deleteissuecode"
      showModal={open}
      onClose={onClose}
      showClose={false}
      title={t('ai.review.reviewAndApprove.issueCodeModalTitle')}
      aria-label={t('ai.review.reviewAndApprove.issueCodeModalTitle')}
      dataTestId="arr-review-delete-issue-code-modal"
      buttons={[
        {
          id: 'cancel-btn',
          label: t('ai.review.reviewAndApprove.cancel'),
          onClick: onClose,
          variant: 'secondary',
          dataTestId: 'ardic-cancel-button',
          className: 'cancel-button',
        },
        {
          id: 'delete-btn',
          label: t('ai.review.reviewAndApprove.delete'),
          onClick: onConfirm,
          variant: 'danger',
          dataTestId: 'ardic-delete-button',
          className: 'delete-button',
        },
      ]}
    >
      <Typography
        className="typo-text body2_size deleteissuecode-modal-description"
        data-testid={`issue-code-delete-modal-issue-code-modal-desc`}
      >
        {t('ai.review.reviewAndApprove.issueCodeModalDesc')}
      </Typography>
    </ArrModal>
  );
};

export default IssueCodeDeleteModal;
